import { render, staticRenderFns } from "./WithKeyboardSelection.vue?vue&type=template&id=28fbda80&"
import script from "./WithKeyboardSelection.vue?vue&type=script&lang=js&"
export * from "./WithKeyboardSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports